"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Auth = void 0;

var msal_browser_1 = require("@azure/msal-browser");

var Cookies = require("js-cookie");

var cookieAttributes = {
  path: "/",
  sameSite: "Lax",
  secure: true
}; // Normally when we reach the /callback url that AzureAd redirected us to,
// msal-browser will NOT handle the hash but redirect to target page first,
// leaving it to the actual target page to trade the authorization code for
// a token. This will not work because the target page may only be accessable
// if we are authenticated. So instead

var DelayedNavigationClient = /*#__PURE__*/function (_msal_browser_1$Navig) {
  (0, _inherits2.default)(DelayedNavigationClient, _msal_browser_1$Navig);

  var _super = _createSuper(DelayedNavigationClient);

  function DelayedNavigationClient() {
    var _this;

    (0, _classCallCheck2.default)(this, DelayedNavigationClient);
    _this = _super.apply(this, arguments);
    _this.delayedNavigation = null;
    return _this;
  }

  (0, _createClass2.default)(DelayedNavigationClient, [{
    key: "navigateNow",
    value: function navigateNow() {
      if (this.delayedNavigation) {
        var _this$delayedNavigati = this.delayedNavigation,
            url = _this$delayedNavigati.url,
            options = _this$delayedNavigati.options;
        this.delayedNavigation = null;

        if (options.noHistory) {
          window.location.replace(url);
        } else {
          window.location.assign(url);
        }

        return new Promise(function (resolve) {
          setTimeout(function () {
            resolve(true);
          }, options.timeout);
        });
      }

      return Promise.resolve(false);
    }
  }, {
    key: "navigateInternal",
    value: function () {
      var _navigateInternal = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(url, options) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.delayedNavigation = {
                  url: url,
                  options: options
                };
                return _context.abrupt("return", false);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function navigateInternal(_x, _x2) {
        return _navigateInternal.apply(this, arguments);
      }

      return navigateInternal;
    }()
  }]);
  return DelayedNavigationClient;
}(msal_browser_1.NavigationClient);

var Auth = /*#__PURE__*/function () {
  function Auth(clientId, tenantId, redirectUri) {
    var scopes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ["openid", "profile"];
    (0, _classCallCheck2.default)(this, Auth);
    var configuration = {
      auth: {
        clientId: clientId,
        authority: "https://login.microsoftonline.com/".concat(tenantId),
        redirectUri: redirectUri,
        navigateToLoginRequestUrl: true
      },
      cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge

      }
    };
    this.clientId = clientId;
    this.scopes = scopes;
    this.client = new msal_browser_1.PublicClientApplication(configuration);
    this.navClient = new DelayedNavigationClient();
    this.client.setNavigationClient(this.navClient);
  }

  (0, _createClass2.default)(Auth, [{
    key: "loginWithRedirect",
    value: function loginWithRedirect(requestedUri) {
      // If we have a requestedUri, make sure we redirect back to this one (instead of the login page)
      // after the login
      var redirectRequest = {
        scopes: this.scopes
      };
      var request = requestedUri ? Object.assign(Object.assign({}, redirectRequest), {
        redirectStartPage: requestedUri
      }) : redirectRequest;
      return this.client.loginRedirect(request);
    }
  }, {
    key: "handleRedirectCallback",
    value: function () {
      var _handleRedirectCallback = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var result, account, idToken, claims;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.client.handleRedirectPromise();

              case 2:
                result = _context2.sent;

                if (result !== null) {
                  /* We came from a redirect. Let's handle it */
                  account = result.account, idToken = result.idToken;

                  if (account) {
                    claims = account.idTokenClaims;
                    this.client.setActiveAccount(account);
                    Cookies.set("AzureADIdentifyServiceProvider.".concat(this.clientId, ".LastAuthUser"), claims.oid, cookieAttributes);
                    Cookies.set("AzureADIdentifyServiceProvider.".concat(this.clientId, ".").concat(claims.oid, ".idToken"), idToken, cookieAttributes);
                  }
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleRedirectCallback() {
        return _handleRedirectCallback.apply(this, arguments);
      }

      return handleRedirectCallback;
    }()
  }, {
    key: "navigateNow",
    value: function () {
      var _navigateNow = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.navClient.navigateNow());

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function navigateNow() {
        return _navigateNow.apply(this, arguments);
      }

      return navigateNow;
    }()
  }]);
  return Auth;
}();

exports.Auth = Auth;
//# sourceMappingURL=auth.js.map